import React from "react";

export const AsteriskIcon = () => {
    return (
        <svg width="19" height="18" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.6667 6.97333L13.04 5.12L13.2667 2.66667L10.86 2.12L9.6 0L7.33333 0.973333L5.06667 0L3.80667 2.12L1.4 2.66L1.62667 5.11333L0 6.97333L1.62667 8.82667L1.4 11.2867L3.80667 11.8333L5.06667 13.9533L7.33333 12.9733L9.6 13.9467L10.86 11.8267L13.2667 11.28L13.04 8.82667L14.6667 6.97333ZM8 10.3067H6.66667V8.97333H8V10.3067ZM8 7.64H6.66667V3.64H8V7.64Z" fill="#0E0D0D"/>
        </svg>

    )
}
